import Button from '~/components/commonUi/Button/Button';
import Input from '~/components/commonUi/Input/Input';
import { observer } from 'mobx-react';
import { getStore } from '~/mobx/AppStore';

interface AddRegionProps {
    onSubmit: () => void;
    onInputChange: (value: string) => void;
    inputValue: string;
    inputError: boolean;
}

const AddRegion = (props: AddRegionProps) => {
    const { onSubmit, onInputChange, inputValue, inputError } = props;

    const handleFormSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        onSubmit();
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onInputChange(event.target.value);
    };

    const labelClassnames = inputError ? 'text-red-600' : '';

    return (
        <form action="" method="post" onSubmit={handleFormSubmit}>
            <div className="flex flex-col items-start w-full gap-4 lg:flex-row lg:items-center">
                <label className={`w-3/12 font-normal ${labelClassnames}`} htmlFor="add_region">
                    Navn
                    <span className="text-red-600">*</span>
                </label>
                <div className="w-full">
                    <Input
                        id="add_region"
                        name="add_region"
                        extendedClassName="w-full"
                        onChange={handleInputChange}
                        value={inputValue}
                        testId="add-region-input"
                        error={inputError}
                    />
                </div>
                <Button type="submit" size="small" btnText="Lagre" testId="btn-save-region" />
            </div>
        </form>
    );
};

const AddRegionWithStore = observer(() => {
    const { regionStore } = getStore();

    return (
        <AddRegion
            inputValue={regionStore.regionName}
            inputError={regionStore.regionNameError}
            onSubmit={regionStore.submitCreateRegion}
            onInputChange={regionStore.updateRegionInput}
        />
    );
});

export default AddRegionWithStore;
